module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "structure-drop"
  }, [_c('span', {
    staticClass: "char-style-override6"
  }, [_vm._v("T")]), _vm._v("he year was 1977 when I first met Karen at the University of Maryland, College Park. She and I had decided to pledge the sisterhood of Zeta Phi Beta that fall. She was line sister one and I was line sister two. When I tell you it was friendship-love at first sight, please believe me. We made an instant connection fueled by our wit, stubbornness, and insatiable sense of humor. You see, Karen was very comfortable with the pledge process as her older brother was a Phi Beta Sigma man and went to the same college. I, on the other hand, knew very little about how and why being a part of this sisterhood could go on to shape the rest o"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("f my")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Karen was also the daughter of the mayor of Seat Pleasant, Maryland. She came from a prominent family where both of her parents were high achievers and expected the same from their children. As Karen’s friend, I had no choice but to adopt those same high expectations and tried dearly to keep up with them. Truth be told, this was the foundation that carried me through to graduation when many of our freshman friends dropped out of college and went home early. Before either of us really could define what going to the “Next Level” meant, Karen was already taking"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v(" me")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Soon after graduation, Karen and I went in different directions. Her entrepreneurial route started with creating the Miss Black USA Pageant, an institution that is determined to, in Karen’s words, help “Black women to claim their power, redefine their destinies, and defy expectations.” Karen went on to create her own women’s leadership coaching, consulting, and luxury travel company where she continues to teach, groom, inspire, and support all who come into contact with her passion and"), _c('span', {
    staticClass: "noBreak2"
  }), _vm._v("b"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("rilliance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As for me, I was determined to kick down doors to the boardrooms of corporate America and started my professional career in the pharmaceutical industry. Twelve years there—followed by twenty-five years in tourism marketing—enabled me to do my Next Level work as an advocate, educator, mentor, and, more importantly, hiring vice president at one of the world’s greatest family destinations on earth. This was my calling. Breaking into tourism as a Black woman executive was not without its obstacles—but the rewards, inroads and insights that I got to share with others made everything"), _c('span', {
    staticClass: "noBreak2"
  }), _vm._v("w"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("orthwhile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After nearly thirty years had passed since Karen and I had last seen each other, I woke up one day and realized, "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("I could seriously use a vacation")]), _vm._v(". I needed to refuel my tank and spend time with my sisters. I booked Karen’s Next Level Bali Retreat. I was hoping for a rejuvenating getaway, but I got so "), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("much")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("more…")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Before the trip even began, Karen and I reconnected by phone, and we talked forever and ever about everything that had happened since our college days and all that we had been through. Next came the long-ass plane ride to Indonesia (long, but so worth it!) and then a week of tropical bliss. Karen and I kept staring at each other in disbelief. In some ways, it felt like centuries since our last meeting. In other ways, it felt like barely a minute h"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("ad")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("passed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Throughout that retreat, we shared our thoughts, constitutions, wit, senses of humor, willpower, words of wisdom, and joy of life with each other. We connected and reconfirmed that we can always go to another level in how deeply we care, share, and motivate. It was really overwhelming at times to be halfway around the world with my dear friend—riding elephants, eating Balinese food, praying in temples, fighting off monkeys, and worshipping in the sun. We both were in total agreement that you cannot give enough, because giving with a pure intention always comes back"), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("threefold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are many different definitions and ways to get to the Next Level in life, love, business, and relationships. You are well on your way by reading this book. Karen is beautiful, unassuming, highly intelligent, and well-traveled; she is absolutely the best person to take us all to the Next Level. She has already influenced my life in so many ways. Now it’s your turn to receive some of Karen’s vision"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("ary")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("magic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Enjoy this book. Read closely. Take notes. Let Karen take you by the hand and lead you into possibilities you hadn’t even considered for yourself. Know that everything is possible. And, wherever you are right now, know that there is always room to grow, to rise, to step into that Next Level Life. There is always another level…and now it’s time to f"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("ind")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("yours.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("—Sheryl Taylor, vice president of Vis"), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "noBreak2"
  }), _c('span', {
    staticClass: "noBreak2"
  }, [_vm._v("Orlando")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db5a9f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/YourNextLevelLife_split_005.vue
// module id = 72
// module chunks = 0